import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'mibi-recovery-view',
    templateUrl: './recovery-view.component.html'
})
export class RecoveryViewComponent {
}
